import React, { useEffect, useState } from "react";
import Layout from "../component/Layout/Layout";
import { Link, useLocation, useParams } from "react-router-dom";
import {
  useProductList,
  useSearchProductList,
} from "../hooks/useAllCategoryData";
import { useInView } from "react-intersection-observer";
import ProductListShimmer from "./ProductListShimmer";
import Breadcrumb from "./Breadcrumbs";
import ProductCardSearch from "./ProductCardSearch";
import CategoryProduct from "./CategoryProduct";

const ProductSearchList = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const searchPage = searchParams.get("q");
  

  const { ref, inView } = useInView();
  const LIMIT = 12;

  const {
    data: product,
    isSuccess,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
    isLoading: loading,
  } = useSearchProductList(searchPage, LIMIT);

  useEffect(() => {
    //console.log("has next page")
    if (inView && hasNextPage) {
      fetchNextPage();
    }
  }, [inView, fetchNextPage, hasNextPage]);

  const [productFilter, setProductFilter] = useState(false);

  const showFilter = () => {
    setProductFilter(!productFilter);
  };

  const contentProductList =
    isSuccess &&
    product.pages.map((page) =>
      page.map((pro, i) => {
        if (page.length === i + 1) {
          return <ProductCardSearch ref={ref} key={pro.id} product={pro} />;
        }
        return <ProductCardSearch key={pro.id} product={pro} />;
      })
    );

  const notfound = (
    <div className="product-notfound">
      <div>
        <h2>We are Sorry!</h2>
        <p>No result found for "{searchPage}"</p>
      </div>
    </div>
  );

  return (
    <Layout
      title="Chaashni Couture: Product"
      description="Chaashni by Maansi & Ketan: Description"
    >
      <div className="site-content-wrap product-list">
        <div className="container">
          <div className="row">
            <div className="col-md-12 breadcrumb">
              <ul>
                <Breadcrumb staticWord="category" />
              </ul>
            </div>

            <div className="productlist-wrap">
              {contentProductList[0]?.length > 0 && (
                <h1 className="sustom-heading-h1 custom-search-heading">Showing Results for <strong>"{searchPage}"</strong></h1>
              )}
              <div className="col-md-12">
                <div className="row">
                  {loading ? (
                    Array.from({ length: 6 }, (_, index) => (
                      <ProductListShimmer key={index} />
                    ))
                  ) : (
                    <>
                      {/* <CategoryProduct searchPage={searchPage}/> */}
                      {/* {contentProductList[0]?.length > 0 && <h2>PRODUCTS</h2>} */}
                      {contentProductList[0]?.length > 0
                        ? contentProductList
                        : notfound}
                      {isFetchingNextPage && (
                        <div className="loading-div">
                          <span>Loading...</span>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ProductSearchList;
